import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import MainLayout from './components/layout/MainLayout';
import LoginPage from './pages/auth/LoginPage';
import HomePage from './pages/home/HomePage';
import AppraisalForm from './pages/appraisal/AppraisalForm';
import EmployeePage from './pages/employees/EmployeePage';
import AppraisalReport from './pages/appraisal-report/AppraisalReport';
import CodeOfConductPage from './pages/code-of-conduct/CodeOfConductPage';
import RnRPage from './pages/rnr/RnRPage';
import LsaPage from './pages/lsa/LsaPage';
import HrmsPage from './pages/hrms/HrmsPage';
import BirthdaysPage from './pages/birthdays/BirthdaysPage';
import './styles/global.css';

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<HomePage />} />
            <Route path="appraisal" element={<AppraisalForm />} />
            <Route path="appraisal/:employeeId" element={<AppraisalForm />} />
            <Route path="appraisal-report" element={<AppraisalReport />} />
            <Route path="employees" element={<EmployeePage />} />
            <Route path="code-of-conduct" element={<CodeOfConductPage />} />
            <Route path="rnr" element={<RnRPage />} />
            <Route path="lsa" element={<LsaPage />} />
            <Route path="hrms" element={<HrmsPage />} />
            <Route path="birthdays" element={<BirthdaysPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;